/**
 * UpcomingRemindersCard — shows mentor sessions + events happening in the
 * next 48 hours. Renders nothing if the member has no upcoming items.
 */
import { Link } from "react-router-dom";
import { Calendar, Users } from "lucide-react";
import { formatDistanceToNow } from "date-fns";
import { useUpcomingReminders } from "@/lib/engagement/useUpcomingReminders";

const UpcomingRemindersCard = () => {
  const { items, loading } = useUpcomingReminders();
  if (loading || items.length === 0) return null;

  return (
    <section className="rounded-2xl border border-border bg-card p-6">
      <h2 className="text-lg font-semibold">Coming up</h2>
      <p className="mt-1 text-xs text-muted-foreground">In the next 48 hours.</p>
      <ul className="mt-4 space-y-2">
        {items.map((item) => (
          <li key={`${item.kind}:${item.id}`}>
            <Link
              to={item.href}
              className="flex items-start gap-3 rounded-xl border border-border/60 px-3 py-2.5 text-sm hover:bg-secondary/40 transition-colors"
            >
              {item.kind === "mentor" ? (
                <Users className="h-4 w-4 mt-0.5 text-primary" />
              ) : (
                <Calendar className="h-4 w-4 mt-0.5 text-primary" />
              )}
              <span className="flex-1">
                <span className="font-medium">{item.title}</span>
                <span className="block text-xs text-muted-foreground mt-0.5">
                  Starts {formatDistanceToNow(new Date(item.startsAt), { addSuffix: true })}
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default UpcomingRemindersCard;
